module.exports = __webpack_public_path__ + "static/img/jjfa4.1aabc9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jjfa4.jpg
// module id = HzXQ
// module chunks = 1